const addPlaceHolders = () => {
    const jetForms = document.querySelectorAll('.jet-fb-form-block');

    jetForms && [...jetForms].forEach( form => {
        const formFields = form?.querySelectorAll('[class*=field-type-]');

        [...formFields].forEach( field => {
            const label = field?.querySelector('.jet-form-builder__label-text')?.innerText;
            const input = field?.querySelector('.jet-form-builder__field');
            const isCheckbox = field?.classList.contains('field-type-checkbox-field');

            if ( isCheckbox ) {
                field.querySelector('.jet-form-builder__label').style.display = 'none';
            }
            
            if(! input?.classList.contains('checkboxes-field') && !input?.classList.contains('file-field') && label !== '') {
                input ? input.placeholder = label : null;
                if ( field?.querySelector('.jet-form-builder__label')) {
                    field.querySelector('.jet-form-builder__label-text').style.display = 'none';
                } 
            }
        })
    });
   
}

export default addPlaceHolders;